<template>
  <button type="button" :class="getClassNameActive" @click="addOrRemove" :disabled="isFetching">
    お気に入り
  </button>
</template>

<script>
import axios from 'axios';
import { APP_URL, API_URL } from '../../../config/const';
import {
  OK,
  CREATED,
  UNAUTHENTICATED,
  UNPROCESSABLE_ENTITY,
  ERROR_MESSAGES,
  numberFormat,
} from '../../../_modules/util';

import getClassName from '../../_mixins/getClassName';

export default {
  mixins: [getClassName],
  props: {
    form: {
      type: Object,
      required: false,
      default: () => {},
    },
    user: {
      type: Object,
      required: false,
      default: () => {},
    },
    media: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      isFetching: false,
      favorite: null,
    };
  },
  computed: {
    isActive() {
      if (this.user === null) return false;

      return this.user.favorites.some(
        (favorite) =>
          favorite.item_id === this.form.item_id &&
          favorite.item_color_id === this.form.item_color_id &&
          favorite.item_size_id === this.form.item_size_id
      );
    },
    getClassNameActive() {
      return [this.getClassName('favorite'), this.isActive ? 'favorite--active' : null];
    },
  },
  watch: {
    user: {
      handler() {
        if (this.user === null) return;

        const [favorite] = this.user.favorites.filter(
          (favorite) =>
            favorite.item_id === this.form.item_id &&
            favorite.item_color_id === this.form.item_color_id &&
            favorite.item_size_id === this.form.item_size_id
        );

        this.favorite = favorite;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async addOrRemove() {
      if (this.isFetching) return;
      await this.switchFetching(true);
      const response = this.isActive
        ? await axios.delete(API_URL + '/favorite/' + this.favorite.id)
        : await axios.post(API_URL + '/favorite', this.form);

      if (response.status === OK) {
        this.$emit('user', response.data);
        await this.switchFetching(false);
        return false;
      }

      if (response.status === UNPROCESSABLE_ENTITY) {
        this.$emit('alert', {
          varient: 'error',
          messages: Object.keys(response.data.errors).flatMap((key) => response.data.errors[key]),
        });
        await this.switchFetching(false);
        return false;
      }

      if (response.status === UNAUTHENTICATED) {
        location.href = APP_URL + '/login';
        return false;
      }

      this.$emit('alert', {
        varient: 'error',
        messages: [ERROR_MESSAGES[response.status]],
      });

      await this.switchFetching(false);
    },
    switchFetching(bool) {
      this.isFetching = bool;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../_sass/mixins';
@import '../../_sass/variables';

.favorite {
  width: 102px;
  height: 25px;
  border: solid 1px currentcolor;
  border-radius: 12.5px;
  box-sizing: border-box;
  margin-left: 23px;
  color: $color__title;
  font-size: 1.2rem;
  font-weight: normal;
  line-height: 1;
  align-self: flex-end;
  display: flex;
  justify-content: center;
  align-items: center;
  &:before {
    content: '';
    background: url(../images/icon_favorite.svg) no-repeat center center;
    background-size: 18.5px auto;
    width: 19px;
    height: 17px;
    margin-right: 4px;
  }
  &--active:before {
    background: url(../images/icon_favorite_active.svg) no-repeat center center;
  }
  &--sp {
    width: 82px;
    height: 20px;
    margin-top: 10px;
    margin-left: 0;
    font-size: 0.9rem;
    &:before {
      background-size: 15px auto;
      width: 15px;
      height: 13px;
    }
  }
}
</style>
